import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SketchPicker } from 'react-color'
import Modal from '../../../../Modal'

export default class Swatch extends Component {
  static propTypes = {
    defaultColor: PropTypes.string,
    color: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
  }

  static defaultProps = {
    onChange: x => x
  }

  state = {
    color: this.props.color || this.props.defaultColor || 'rgb(0,0,0)',
    open: false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.color && nextProps.color !== this.props.color) {
      this.setState({ color: nextProps.color })
    }
  }

  show = () => this.setState({ open:true })
  hide = () => this.setState({ open:false })

  handleColor = data => {
    const { r, g, b, a } = data.rgb
    const color = `rgba(${r}, ${g}, ${b}, ${a})`
    this.setState({ color })
    this.props.onChange(color)
  }

  render() {
    const { name, label } = this.props
    const { color, open } = this.state
    return (
      <div className="swatch" onClick={this.show}>
        <div className="swatch-preview">
          <div className="swatch-box">
            <div className="swatch-transparency"/>
            <div className="swatch-color" style={{background: color}}/>
          </div>
        </div>
        <input type="hidden" name={name} value={color}/>
        {label && (
          <label>{label}</label>
        )}
        <Modal isOpen={open} onRequestClose={this.hide}>
          <SketchPicker
            color={color}
            onChangeComplete={this.handleColor} />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Design/Swatch.js